import React, { useState } from 'react';
import axios from '../api/axiosConfig';
import './Modal.css';

const TramiteEliminacionesModal = ({ isOpen, requests, onClose, onSuccess }) => {
  const [processingId, setProcessingId] = useState(null);

  if (!isOpen) return null;

  const handleAction = async (id, action) => {
    if (action === 'deny') {
      if (!window.confirm('¿Está seguro de denegar esta solicitud? El trámite regresará a su estado anterior.')) {
        return;
      }
    } else {
      if (!window.confirm('¿Está seguro de aprobar la eliminación? El trámite se marcará como eliminado y su placa será liberada.')) {
        return;
      }
    }

    try {
      setProcessingId(id);
      await axios.post(`/api/tramites/${id}/resolve-deletion`, { action });
      onSuccess();
    } catch (err) {
      alert(err.response?.data?.message || 'Error al procesar la solicitud');
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '800px', width: '90%' }}>
        <div className="modal-header">
          <h2>🗑️ Solicitudes de Eliminación</h2>
          <button className="btn-close" onClick={onClose}>&times;</button>
        </div>

        <div className="modal-body" style={{ padding: '20px', maxHeight: '60vh', overflowY: 'auto' }}>
          {(!requests || requests.length === 0) ? (
            <div style={{ textAlign: 'center', color: '#64748b', padding: '20px' }}>
              No hay solicitudes de eliminación pendientes.
            </div>
          ) : (
            <table className="users-table" style={{ width: '100%', textAlign: 'left', borderCollapse: 'collapse' }}>
              <thead>
                <tr style={{ background: '#f8fafc' }}>
                  <th>ID</th>
                  <th>Placa Ref</th>
                  <th>Solicitante</th>
                  <th>Motivo</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {requests.map((r) => (
                  <tr key={r.id} style={{ borderBottom: '1px solid #e2e8f0' }}>
                    <td data-label="ID"><strong>#{r.id}</strong></td>
                    <td data-label="Placa Ref">
                      {(r.plate || r.datos_adicionales?.placa_referencia) ? (
                        <span className="plate-badge-sm">{r.plate || r.datos_adicionales.placa_referencia}</span>
                      ) : '—'}
                    </td>
                    <td data-label="Solicitante">{r.creador_name}</td>
                    <td data-label="Motivo" style={{ maxWidth: '250px', whiteSpace: 'normal', fontSize: '13px', color: '#475569' }}>
                      {r.deletion_reason || 'Sin motivo especificado'}
                    </td>
                    <td data-label="Acciones">
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button
                          className="btn-primary"
                          disabled={processingId === r.id}
                          onClick={() => handleAction(r.id, 'approve')}
                          style={{ background: '#ef4444', borderColor: '#ef4444', color: 'white', padding: '6px 10px', fontSize: '12px' }}
                        >
                          Aprobar
                        </button>
                        <button
                          className="btn-secondary"
                          disabled={processingId === r.id}
                          onClick={() => handleAction(r.id, 'deny')}
                          style={{ padding: '6px 10px', fontSize: '12px' }}
                        >
                          Denegar
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default TramiteEliminacionesModal;
